/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

// defined in its own file to improve webpack hot module reloading support.
// some non-react code uses AbButtonType, but not AbButton.  This change
// allows code like this to avoid importing AbButton

// AbButton type
export let AbButtonType = /*#__PURE__*/function (AbButtonType) {
  AbButtonType["DEFAULT"] = "";
  AbButtonType["PRIMARY"] = "ab-button-primary";
  AbButtonType["SUBMIT"] = "ab-button-submit";
  AbButtonType["SUCCESS"] = "ab-button-success";
  AbButtonType["INFO"] = "ab-button-info";
  AbButtonType["WARNING"] = "ab-button-warning";
  AbButtonType["DANGER"] = "ab-button-danger";
  AbButtonType["LINK"] = "ab-button-link";
  return AbButtonType;
}({});
//# sourceMappingURL=AbButtonType.js.map
